import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { cn } from "../lib/utils";

export function RecentActivity({ items, emptyKey, renderItem, to, testId }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-testid={testId}>
      <div className="mb-3 flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.18em] text-white/50">
          {t(emptyKey.titleKey)}
        </span>
        {to ? (
          <Link
            to={to}
            className="inline-flex items-center gap-1 text-xs text-[#D4AF37] hover:text-[#F4D77A] transition-colors"
            data-testid={`${testId}-seeall`}
          >
            {t("dashboard.seeAll")} <ArrowRight className="h-3 w-3" />
          </Link>
        ) : null}
      </div>

      {!items || items.length === 0 ? (
        <p className="text-sm text-white/45" data-testid={`${testId}-empty`}>
          {t("dashboard.emptyRecent")}
        </p>
      ) : (
        <ul className={cn("space-y-2.5")}>
          {items.map((it, i) => (
            <li key={i}>{renderItem(it, i)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RecentActivity;
